class Visit {
  constructor(
    id,
    carOwnership,
    workshopOwnership,
    scheduledTime,
    messageFromClient,
    messageFromWorkshop,
    status,
    timePreference,
    timePropositions,
    alternativeTimePropositions,
    contact,
    car,
    workshop,
    workshopRejectedVisit,
    issuingInvoice,
    serviceScopeStatus,
    isReviewed,
    initiatedBy,
    paymentStatus,
  ) {
    this.id = id;
    this.carOwnership = carOwnership;
    this.workshopOwnership = workshopOwnership;
    this.scheduledTime = scheduledTime;
    this.messageFromClient = messageFromClient;
    this.messageFromWorkshop = messageFromWorkshop;
    this.status = status;
    this.timePreference = timePreference;
    this.timePropositions = timePropositions;
    this.alternativeTimePropositions = alternativeTimePropositions;
    this.contact = contact;
    this.car = car;
    this.workshop = workshop;
    this.workshopRejectedVisit = workshopRejectedVisit;
    this.issuingInvoice = issuingInvoice;
    this.serviceScopeStatus = serviceScopeStatus;
    this.isReviewed = isReviewed;
    this.initiatedBy = initiatedBy;
    this.paymentStatus = paymentStatus;
  }
}

export default Visit;
